var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoAudioMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99966 15.1648C8.9691 15.1648 10.5713 13.5626 10.5713 11.5933V3.57147C10.5713 1.60201 8.9691 0 6.99966 0C5.03022 0 3.42822 1.60201 3.42822 3.57147V11.5935C3.42822 13.5628 5.03022 15.1648 6.99966 15.1648Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7401 9.45831H12.029C11.8006 9.45831 11.6153 9.64369 11.6153 9.87211V11.3264C11.6153 13.8712 9.54464 15.9419 6.99961 15.9419C4.45459 15.9419 2.38439 13.8712 2.38439 11.3264V9.87211C2.38439 9.64369 2.19901 9.45831 1.9706 9.45831H1.25949C1.03108 9.45831 0.845703 9.64369 0.845703 9.87211V11.3264C0.845703 14.3692 3.21114 17.0506 6.23037 17.4311V18.4615H3.05452C2.82611 18.4615 2.64073 18.6469 2.64073 18.8753V19.5862C2.64073 19.8146 2.82611 20 3.05452 20H10.9451C11.1735 20 11.3589 19.8146 11.3589 19.5862V18.8753C11.3589 18.6469 11.1735 18.4615 10.9451 18.4615H7.76906V17.4311C10.7885 17.0508 13.1537 14.3692 13.1537 11.3264V9.87211C13.1539 9.64349 12.9686 9.45831 12.7401 9.45831Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoAudioMute);
export default __webpack_public_path__ + "static/media/video-audio-mute.01729c2598b13628d791c647dad12932.svg";
export { ForwardRef as ReactComponent };